import { ReactNode, SyntheticEvent } from 'react';

import { TSvgProps } from '@r1-frontend/ui-react/components/svg/createSvg';
import { InfoCircleFlip } from '@r1-frontend/ui-react/components/svg/main';
import { H4, THBaseProps, THStaticSize } from '@r1-frontend/ui-react/components/typography/heading';

export type TSubscriptionTitleProps = {
    Icon?: (props: TSvgProps) => JSX.Element,
    iconSize?: 16 | 20,
    children: string | ReactNode,
    onClick: (e: SyntheticEvent) => void,
};

const SubscriptionTitle = ({ Icon = InfoCircleFlip, iconSize = 16, children, ...props }: TSubscriptionTitleProps): JSX.Element => {
    let headerProps: THBaseProps = {
        $withIndent: false,
        $inline: true,
    };
    const mobile: THStaticSize = { $mobile: true };
    const desktop: THStaticSize = { $desktop: true };

    if (iconSize === 16) {
        headerProps = { ...headerProps, ...mobile };
    } else {
        headerProps = { ...headerProps, ...desktop };
    }

    return (
        <H4 {...props} {...headerProps}>
            <Icon size={iconSize}/>
            {children}
        </H4>
    );
};

export default SubscriptionTitle;
